"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["className", "color", "block", "outline"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function ButtonLink(props) {
  var className = props.className,
    color = props.color,
    block = props.block,
    outline = props.outline,
    rest = _objectWithoutProperties(props, _excluded);
  var cn = (0, _classnames["default"])('btn', "btn-".concat(outline ? 'outline-' : '').concat(color), block && 'btn-block', className);
  return /*#__PURE__*/_react["default"].createElement("a", _extends({
    className: cn
  }, rest, {
    rel: "noopener norefer"
  }));
}
ButtonLink.propTypes = {
  type: _propTypes["default"].string,
  color: _propTypes["default"].string,
  block: _propTypes["default"].bool,
  outline: _propTypes["default"].bool,
  href: _propTypes["default"].string
};
ButtonLink.defaultProps = {
  color: 'primary',
  block: false,
  outline: false
};
var _default = exports["default"] = ButtonLink;